module.exports = __webpack_public_path__ + "static/media/icon-user.d546943b.svg";